


















import {AxiosError, AxiosResponse} from 'axios';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import {CONFIG} from '@/config';
import moment from 'moment';

import {httpService} from '@/services';

@Component({
  components: {}
})
export default class RegistrationSegmentRegionOld extends Vue {
  @Prop({required: true})
  dataQuery: any;

  public totalYears: number = 3;

  @Watch('dataQuery')
  public requestData() {
    this.getExcel();
  }

  private getExcelMunicipio(yearInitial: any, monthInitial: any, yearFinal: any, monthFinal: any) {
    httpService.httpBlob
        .post(`${CONFIG.URL.NEODASH_API}/api/gigdash/extractProduct/${yearInitial}/${monthInitial}/${yearFinal}/${monthFinal}`)
        .then((res: AxiosResponse) => {
          const blob = new Blob([res.data], {
            type: 'application/xlsx'
          });
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName:
                `Emplacamento_por_Segmento_e_versao_por_municipio` +
                moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') +
                `.xlsx`
          });
        })
        .catch((err: AxiosError) => {
          console.log('Error', err);
        });
  }

  private getExcelBairro(yearInitial: any, monthInitial: any, yearFinal: any, monthFinal: any) {
    httpService.httpBlob
        .post(`${CONFIG.URL.NEODASH_API}/api/gigdash/extractProductCity/${yearInitial}/${monthInitial}/${yearFinal}/${monthFinal}`)
        .then((res: AxiosResponse) => {
          const blob = new Blob([res.data], {
            type: 'application/xlsx'
          });
          kendo.saveAs({
            dataURI: window.URL.createObjectURL(blob),
            fileName:
                `Emplacamento_por_Segmento_e_versao_por_bairro` + moment(new Date()).format('YYYY_MM_DD-hh_mm_ss') + `.xlsx`
          });
        })
        .catch((err: AxiosError) => {
          console.log('Error', err);
        });
  }

  public getExcel() {
    switch (this.dataQuery.tipo_localidade.value) {
      case 1:
        this.getExcelMunicipio(this.dataQuery.ano_inicial.value, this.dataQuery.mes_inicial.value, this.dataQuery.ano_final.value, this.dataQuery.mes_final.value);
        break;
      case 2:
        this.getExcelBairro(this.dataQuery.ano_inicial.value, this.dataQuery.mes_inicial.value, this.dataQuery.ano_final.value, this.dataQuery.mes_final.value);
        break;
      default:
        console.log('Enter the type of location..');
    }
  }

  public created() {
    this.requestData();
  }
}
